import { render, staticRenderFns } from "./addlog.vue?vue&type=template&id=c0a28970&scoped=true"
import script from "./addlog.vue?vue&type=script&lang=js"
export * from "./addlog.vue?vue&type=script&lang=js"
import style0 from "./addlog.vue?vue&type=style&index=0&id=c0a28970&prod&lang=less"
import style1 from "./addlog.vue?vue&type=style&index=1&id=c0a28970&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a28970",
  null
  
)

export default component.exports